import axios from 'axios';
import { API_URL } from '../../global/components/Constants';

export const getUser = async () => {
    try {
      const response = await axios.get(`${API_URL}user/user`, {withCredentials: true});
      const obj = response.data;
      if(obj.Success){
          if(obj.Data != null){
            return obj.Data;
          }
      }
      return null;
    } catch (error) {
      return null;
    }
}

export const userThirdPartyLogin = async (payload) => {
    try {
        const response = await axios.post(`${API_URL}user/user_third_party_login`, payload, {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

